import React from 'react';
import { DashboardHeader } from './components/dashboard/DashboardHeader';
import { TodaySnapshot } from './components/dashboard/TodaySnapshot';
import { MonthlyProgress } from './components/dashboard/MonthlyProgress';
import { PerformanceGrid } from './components/dashboard/PerformanceGrid';
import { PointsBreakdownTable } from './components/dashboard/PointsBreakdownTable';
import { PenaltyRules } from './components/dashboard/PenaltyRules';
import { ActivePipeline } from './components/dashboard/ActivePipeline';
import { PathToSeniorProcessor } from './components/dashboard/PathToSeniorProcessor';
import { CompensationLadder } from './components/dashboard/CompensationLadder';
import { RankComparison } from './components/dashboard/RankComparison';
import { ValuesFooter } from './components/dashboard/ValuesFooter';
export function App() {
  return <div className="min-h-screen bg-[#F5F7FB] pb-12" data-id="element-0">
      <DashboardHeader data-id="element-1" />

      <main className="max-w-[1600px] mx-auto px-4 md:px-6 pt-6 space-y-6" data-id="element-2">
        {/* Top Row: KPIs and Progress */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-stretch" data-id="element-3">
          <TodaySnapshot data-id="element-4" />
          <MonthlyProgress data-id="element-5" />
        </div>

        {/* Performance Grid (clickable metric cards) */}
        <PerformanceGrid data-id="element-6" />

        {/* Table and Penalties Row */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 items-stretch" data-id="element-7">
          <div className="xl:col-span-2" data-id="element-8">
            <PointsBreakdownTable data-id="element-9" />
          </div>
          <div className="xl:col-span-1" data-id="element-10">
            <PenaltyRules data-id="element-11" />
          </div>
        </div>

        {/* Active Pipeline with filters */}
        <ActivePipeline data-id="element-12" />

        {/* Advancement Section */}
        <div className="pt-8" data-id="element-13">
          <h2 className="text-2xl font-black text-[#0A1F5C] uppercase tracking-widest text-center mb-8" data-id="element-14">
            Advancement & Compensation
          </h2>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-stretch" data-id="element-15">
            <PathToSeniorProcessor data-id="element-16" />
            <CompensationLadder data-id="element-17" />
          </div>
        </div>

        {/* Rank Comparison Roadmap */}
        <RankComparison data-id="element-18" />

        {/* Footer */}
        <ValuesFooter data-id="element-19" />
      </main>
    </div>;
}